import { defineComponent } from "vue";
import { mapState } from "vuex";

// Components
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Typography from "@/components/general/Typography";
import Button from "@/components/general/Button";
import useInputs from "@/components/general/Inputs";
import EstadoLegal from "@/components/datatables/EstadoLegal.vue";
import EstadoFlag from "@/components/datatables/EstadoFlag.vue";
import ActionsLegal from "@/components/datatables/ActionsLegal.vue";
import ModalListSecurityAnswer from "@/views/Legal/Security/componets/modals/ModalListSecurityAnswer.vue";
import ModalSuccess from "@/views/Legal/Security/componets/modals/ModalSuccess.vue";
import ModalError from "@/views/Legal/Security/componets/modals/ModalError.vue";
import ModalBlocked from "@/views/Legal/Security/componets/modals/ModalBlocked.vue";
import ModalSecurityAnswer from "@/views/Legal/Security/componets/modals/ModalSecurityAnswer.vue";
// services
import processSevices from "@/services/legal/service.js";
import securitySevices from "@/services/legal/security/service.js";

const { Input, Select, Date, File } = useInputs();

export default defineComponent({
  components: {
    MainBarMenuV2,
    HeadingUser,
    Typography,
    Button,
    Input,
    Select,
    Date,
    File,
    ModalListSecurityAnswer,
    ModalSuccess,
    ModalError,
    ModalBlocked,
    ModalSecurityAnswer,
  },
  data() {
    return {
      isFilter: false,
      isBusy: false,
      isBusyExport: false,
      valuesFilter: {
        start_date: "",
        end_date: "",
        city_id: null,
        status: null,
        risk: null,
        file_number: null,
        demandante: null,
        defendants: null,
        court_id: null,
        lawyer_id: null,
        laborUnion: null,
        plaintiff_name: null,
        object_id: null,
      },
      pagina: 1,
      options: {
        status: [],
        defendants: [],
        courts: [],
        cities: [],
        risk_level: [],
        lawyers: [],
        unions: [],
        authorities: [],
        objects: [],
      },
      pagination: {},
      datatable: {
        filter: "",
        total: 0,
        per_page: 10,
        page: 1,
        last_page: 1,
        columns: [
          {
            label: "No. Radicado",
            field: "file_number",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Demandante",
            field: "plaintiff_name",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Tipo",
            field: "process_type.name",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Ciudad",
            field: "city.name",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Ultima actualización",
            field: "updated_at",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
            representedAs: ({ updated_at }) =>
              this.$moment(updated_at).format("LL"),
            interpolate: true,
          },
          {
            label: "Riesgo",
            align: "left",
            sortable: true,
            component: EstadoFlag,
            headerClass: "text-left table-th",
          },
          {
            label: "Estado",
            field: "status",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
            component: EstadoLegal,
          },
          {
            label: "Predicción",
            field: "prediction",
            align: "left",
            sortable: true,
            headerClass: "text-left table-th",
          },
          {
            label: "Administrar",
            align: "center",
            component: ActionsLegal,
            headerClass: "text-center table-th",
          },
        ],
        rows: [],
      },
      plaintiffs: [],
      messageModal: null,
      isFirstTime: false,
      isInactive: false,
    };
  },
  methods: {
    getDatafilter() {
      console.log("get data");
    },
    goCreate() {
      this.$router.push("process/create");
    },
    clearFilter() {
      this.valuesFilter = {
        start_date: "",
        end_date: "",
        city_id: null,
        status: null,
        risk: null,
        file_number: null,
        demandante: null,
        defendants: null,
        court_id: null,
        lawyer_id: null,
        laborUnion: null,
        plaintiff_name: null,
        object_id: null,
      };
      if (this.isFilter) {
        processSevices.getListProcess().then((response) => {
          this.isFilter = false;
          this.datatable.rows = response.data;
          this.datatable.total = response.meta.total;
          this.datatable.per_page = response.meta.per_page;
          this.datatable.last_page = response.meta.last_page;
          this.datatable.page = response.meta.current_page;
        });
      }
    },
    initData() {
      processSevices.getListProcess().then((response) => {
        this.datatable.rows = response.data;
        this.datatable.total = response.meta.total;
        this.datatable.per_page = response.meta.per_page;
        this.datatable.last_page = response.meta.last_page;
        this.datatable.page = response.meta.current_page;
      });

      processSevices.getOptions().then((response) => {
        this.options = {
          status: response.data?.status,
          defendants: response.data?.defendants,
          courts: response.data?.courts,
          cities: response.data?.cities,
          risk_level: response.data?.risk_level,
          lawyers: response.data?.lawyers,
          unions: response.data?.unions,
          authorities: [],
          objects: response.data?.objects,
        };
      });

      this.loadPlainiffs();
    },
    onSubmitFilter() {
      const me = this;
      me.isBusy = true;
      const searchValue = {
        ...(me.valuesFilter.start_date && {
          start_date: me.valuesFilter.start_date,
        }),
        ...(me.valuesFilter.end_date && { end_date: me.valuesFilter.end_date }),
        ...(me.valuesFilter.status && { status: me.valuesFilter.status.id }),
        ...(me.valuesFilter.city_id && { city_id: me.valuesFilter.city_id.id }),
        ...(me.valuesFilter.risk && { risk: me.valuesFilter.risk.id }),
        ...(me.valuesFilter.file_number && {
          file_number: me.valuesFilter.file_number,
        }),
        ...(me.valuesFilter.demandante && {
          plaintiff: me.valuesFilter.demandante,
        }),
        ...(me.valuesFilter.defendants && {
          defendants: me.valuesFilter.defendants.id,
        }),
        ...(me.valuesFilter.court_id && {
          court_id: me.valuesFilter.court_id.id,
        }),
        ...(me.valuesFilter.lawyer_id && {
          lawyer_id: me.valuesFilter.lawyer_id.id,
        }),
        ...(me.valuesFilter.plaintiff_name && {
          plaintiff_name: me.valuesFilter.plaintiff_name.id,
        }),
        ...(me.valuesFilter.object_id && {
          object_id: me.valuesFilter.object_id.id,
        }),
        "unions[0]": me.valuesFilter.laborUnion?.id,
      };
      processSevices
        .getListProcess(searchValue)
        .then((response) => {
          this.isFilter = true;
          this.datatable.rows = response.data;
          this.datatable.total = response.meta.total;
          this.datatable.per_page = response.meta.per_page;
          this.datatable.last_page = response.meta.last_page;
          this.datatable.page = response.meta.current_page;
        })
        .finally(() => {
          me.isBusy = false;
        });
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    deleteProcess() {
      processSevices.deleteProcess(this.process.idDelete).then((response) => {
        if (!response.error) {
          this.initData();
          this.closeModal("modal-delete");
          this.$bvToast.toast("Los Datos se guardaron correctamente", {
            title: "Datos guardados",
            autoHideDelay: 7000,
            appendToast: true,
            variant: "success",
            solid: true,
            noCloseButton: true,
          });
        } else {
          this.$bvToast.toast("Los Datos no se guardaron correctamente", {
            title: "Datos no guardados",
            autoHideDelay: 7000,
            appendToast: true,
            variant: "danger",
            solid: true,
            noCloseButton: true,
          });
        }
      });
    },
    exportReport() {
      const data = {
        ...(this.valuesFilter.start_date && {
          start_date: this.valuesFilter.start_date,
        }),
        ...(this.valuesFilter.end_date && {
          end_date: this.valuesFilter.end_date,
        }),
        ...(this.valuesFilter.status && {
          status: this.valuesFilter.status.id,
        }),
        ...(this.valuesFilter.file_number && {
          file_number: this.valuesFilter.file_number,
        }),
        ...(this.valuesFilter.courts && {
          courts: this.valuesFilter.courts.id,
        }),
        ...(this.valuesFilter.demandante && {
          plaintiff: this.valuesFilter.demandante,
        }),
        ...(this.valuesFilter.defendants && {
          defendants: this.valuesFilter.defendants.id,
        }),
        ...(this.valuesFilter.city && { city: this.valuesFilter.city.id }),
        ...(this.valuesFilter.risk && { risk: this.valuesFilter.risk.id }),
        ...(this.valuesFilter.authority && {
          authority: this.valuesFilter.authority.id,
        }),
        ...(this.valuesFilter.lawyer && {
          lawyer: this.valuesFilter.lawyer.id,
        }),
        ...(this.valuesFilter.laborUnion && {
          laborUnion: this.valuesFilter.laborUnion.id,
        }),
        ...(this.valuesFilter.object && {
          object: this.valuesFilter.object.id,
        }),
      };
      //window.open(`${this.backendPath}/ml-labor-processes-export${map_query(data)}`, '_blank')
      this.isBusyExport = true;
      processSevices
        .getExportProcess(data)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `reporte_procesos.xlsx`); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.isBusyExport = false;
        });
    },
    importData(e) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      processSevices.sendImport(formData).then((response) => {
        if (!response.error) {
          this.makeToast("Los datos se guardaron correctamente.", "success");
          this.initData();
        } else {
          Object.values(response.data).forEach((v) =>
            this.makeToast(v, "danger")
          );
        }
      });
    },
    makeToast(msg, color) {
      this.toastCount++;
      this.$bvToast.toast(msg, {
        title: "Importación de datos",
        autoHideDelay: 7000,
        appendToast: true,
        variant: color,
        solid: true,
        noCloseButton: true,
      });
    },
    async loadPlainiffs() {
      const me = this;
      try {
        const { data } = await processSevices.getPlaintiffs();
        me.plaintiffs = data?.plaintiffs.map((item) => {
          return {
            id: item?.plaintiff_name,
            name: item?.plaintiff_name,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    async loadMySecurityStatus() {
      const me = this;
      try {
        me.isFirstTime = false;
        const { data } = await securitySevices.getMySecurityStatus();
        if (data?.is_blocked) {
          me.$bvModal.show("modal-blocked-security");
        } else if (data?.is_first_time && !data?.is_active) {
          me.isFirstTime = true;
          me.$bvModal.show("modal-list-security-answers");
        } else if(!data?.is_first_time && !data?.is_active) {
          me.isInactive = true;
          me.$bvModal.show("modal-security-answer");
        }
      } catch (error) {
        console.log(error);
      }
    },
    onSuccess(messageModal) {
      const me = this;
      me.initData();
      me.messageModal = messageModal;
      me.$bvModal.hide("modal-list-security-answers");
      me.$bvModal.hide("modal-security-answer");
      me.$bvModal.show("modal-success");
    },
    onError(messageModal) {
      const me = this;
      me.messageModal = messageModal;
      me.$bvModal.show("modal-fail");
    },
    onBlocked() {
      const me = this;
      me.$bvModal.hide("modal-security-answer");
      me.$bvModal.show("modal-blocked-security");
    }
  },
  async mounted() {
    const me = this;
    await me.loadMySecurityStatus();
    me.initData();
  },
  computed: {
    isDisabled() {
      return Object.values(this.valuesFilter).some(
        (filter) => filter !== null && filter !== ""
      );
    },
    ...mapState(["process"]),
  },
  watch: {
    pagina() {
      processSevices.getListProcess({ page: this.pagina }).then((response) => {
        this.datatable.rows = response.data;
        this.datatable.total = response.meta.total;
        this.datatable.per_page = response.meta.per_page;
        this.datatable.last_page = response.meta.last_page;
        this.datatable.page = response.meta.current_page;
      });
    },
  },
});
